export function createEstablishmentObject(establishmentDataObject) {

  if(!establishmentDataObject) {
      return false;
    }

    return {
      establishmentName: establishmentDataObject.establishment_name,
      companyName: establishmentDataObject.company.company_name,
      ein: establishmentDataObject.ein.ein,
      streetAddress: establishmentDataObject.address.street,
      city: establishmentDataObject.address.city,
      state: establishmentDataObject.address.state.toUpperCase(),
      zipCode: formatZip(establishmentDataObject.address.zip),
      size: establishmentDataObject.size,
      naicsCode: establishmentDataObject.naics.naics_code,
      industryDescription: establishmentDataObject.naics.industry_description,
      establishmentType: establishmentDataObject.establishment_type,
      establishment_status: establishmentDataObject.establishment_status,
      removalReason: establishmentDataObject.removal_reason,
      id: establishmentDataObject.id || null,
      naicsYear: establishmentDataObject.naics.year,
      naics: establishmentDataObject.naics.naics_code + ' ' + (establishmentDataObject.naics.industry_description || ""),
      totalExpectedCases: establishmentDataObject.expected_cases_count,
      totalSubmittedCases: establishmentDataObject.total_submitted_cases,
      requiredToFile301: establishmentDataObject.required_to_file301
    };
}

export function createEmptyEstablishmentObject() {
  return {
    establishmentName: '',
    ein: '',
    companyName: '',
    userEstablishmentId: '',
    establishment_status: 1,
    streetAddress: '',
    city: '',
    state: '',
    zipCode: '',
    size: '',
    naicsCode: '',
    industryDescription: '',
    establishmentType: '',
    naicsYear: '2012',
    naics: ''
  };
}

export function createEstablishmentObjectForApi(establishment) {
  let establishmentApiObject = {};
  establishmentApiObject.address = {};
  establishmentApiObject.naics = {};
  establishmentApiObject.company = {};
  establishmentApiObject.ein = {};

  if(establishment.establishmentName) {
    establishmentApiObject.establishment_name = establishment.establishmentName;
  }

  establishmentApiObject.company.company_name = establishment.companyName || null;
  establishmentApiObject.ein.ein = establishment.ein || null;
  // if(establishment.ein) {
  //   establishmentApiObject.ein = establishment.ein || null;
  // }
  if(establishment.streetAddress) {
    establishmentApiObject.address.street = establishment.streetAddress;
  }
  if(establishment.state) {
    establishmentApiObject.address.state = establishment.state;
  }
  if(establishment.city) {
    establishmentApiObject.address.city = establishment.city;
  }
  if(establishment.zipCode) {
    establishmentApiObject.address.zip = prepareZip(establishment.zipCode);
  }
  if(establishment.naicsCode) {
   establishmentApiObject.naics.naics_code = establishment.naicsCode;
  }
  if(establishment.industryDescription) {
    establishmentApiObject.naics.industry_description = establishment.industryDescription;
  }
  if(establishment.size) {
    establishmentApiObject.size = establishment.size;
  }
  if(establishment.establishmentType) {
   establishmentApiObject.establishment_type = establishment.establishmentType;
  }
  if(establishment.id) {
    establishmentApiObject.id = establishment.id;
  }
  return establishmentApiObject;
}

function formatZip(zip) {
  let formattedZip = "";
  if (zip.length > 5) {
    formattedZip = zip.substring(0, 5) + '-' + zip.substring(5, zip.length);
  } else {
    formattedZip = zip;
  }
  return formattedZip;
}

function prepareZip(zipCode) {
  const zipArray = zipCode.split('-');
  if(zipArray[1]) {
    return zipArray[0] + zipArray[1];
  } else {
    return zipArray[0];
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/establishment/establishmentModel.js
 **/